export const TOGGLE_DATA_SET_FILTER_VISIBILITY = "TOGGLE_DATA_SET_FILTER_VISIBILITY";

export const toggleDataSetFilterVisibilityAction = (filterId: number, visibility: boolean) => {
    return {
        type: TOGGLE_DATA_SET_FILTER_VISIBILITY,
        filterId: filterId,
        visibility: visibility,
    };
};
